export const ASSIGNMENT_STRINGS = {
    ASSIGNMENT_NAME: "Assignment Name",
    SEARCH_ASSIGNMENT: "Search Assignment",
    CLOSE_ASSIGNMENT: "Close Assignment(s)",
    COMPLETE_ASSIGNMENT: "Complete Assignment(s)",
    CONFIRM_CLOSE: "Confirm Close",
    CONFIRM_COMPLETE: "Confirm Complete",
    OUT_OF: "out of",
    ASSIGNMENTS_SELECTED: "assignment(s) selected",
    BE_CLOSED: "will be closed.",
    BE_COMPLETED: "will be completed.",
    NONE_ASSIGNMENTS_SELECTED: "None of the selected assignments are in a",
    CLOSABLE_STATUS: "closable status (Completed).",
    COMPLETABLE_STATUS: "completable status (Assigned).",
};

export const ASSIGNMENT_KEYS = {
    ID: "id",
    ASSIGNMENT_NAME: "assignmentname",
};

export const ASSIGNMENT_STATUS = {
    COMPLETED: "completed",
    CLOSED: "closed",
    ASSIGNED: "assigned",
}

export const ASSIGNMENT_ACTIONS = {
    CLOSE: "Close",
    COMPLETE: "Complete",
};

export const ASSIGNMENT_TABLE_COLUMNS = [
    { id: "select", isSortable: false, label: "Select" },
    { id: "id", isSortable: true, label: "Assignment ID" },
    { id: "status", isSortable: true, label: "Status" },
    { id: "workerId", isSortable: true, label: "Worker" },
    { id: "assignedAtDate", isSortable: true, label: "Assign Time" },
    { id: "jobid", isSortable: true, label: "Job" },
    { id: "queue", isSortable: true, label: "Queue" }
];

export const ASSIGNMENT_TABLE_COLUMN_KEYS = {
    ID: "id",
    SELECT: "select",
    STATUS: "status",
    ACTIONS: "actions",
    ASSIGNMENT_NAME: "assignmentname",
    CREATE_DATE: "createdate"
};

export const ASSIGNMENT_MESSAGES = {
    NO_ASSIGNMENT: "No assignment to display",
    ASSIGNMENT_ADDED: "Assignment added successfully!",
    ASSIGNMENT_UPDATED: "Assignment updated successfully!",
    ASSIGNMENT_CLOSED: "Assignment(s) closed successfully!",
    ASSIGNMENT_COMPLETED: "Assignment(s) completed successfully!",
};

export const ASSIGNMENT_ERRORS = {
    ADD_ASSIGNMENT_ERROR: "Error adding assignment:",
    SAVE_ASSIGNMENT_ERROR: "Error saving assignment:",
    UPDATE_ASSIGNMENT_ERROR: "Error updating assignment:",
    FETCH_ASSIGNMENT_ERROR: "Error fetching assignment:",
    DELETE_ASSIGNMENT_ERROR: "Error deleting assignment",
    COMPLETE_ASSIGNMENT_ERROR: "Error completing assignment",
    CLOSE_ASSIGNMENT_ERROR: "Error close assignment",
};

